import { withStyles } from '@material-ui/core/styles'
import FormControlLabel from '@material-ui/core/FormControlLabel'

const CustomFormControlLabel = withStyles({
  root: {
    marginLeft: 0
  },
  label: {}
})(FormControlLabel)

export const BoldCustomFormControlLabel = withStyles({
  label: {
    fontWeight: 'bold'
  }
})(CustomFormControlLabel)

export default CustomFormControlLabel
